export class ConLogEntity{
    id:number;
    controlPanelId:number;
    viewDate:string;
    personId:number;

    constructor(){}
}